import React from 'react'
const displayMissingFieldWarning = (fieldName, key) => {
  return (
    <div className="alert alert-danger" role="alert" {...(key && { key })}>
      <strong>Warning:</strong> <em>{fieldName}</em> is missing or broken.
    </div>
  )
}

export default displayMissingFieldWarning